import PropTypes from 'prop-types';

export const FILE_TYPE = PropTypes.shape({
  name: PropTypes.string,
  autoSaveId: PropTypes.string,
  rotation: PropTypes.number,
  jsFileObject: PropTypes.instanceOf(File),
  thumbnailURL: PropTypes.string,
  type: PropTypes.string,
});

export default {};
